import React from "react";
import { Typography } from "@material-ui/core";
import CommonPage from "@icarius-common/commonPage";
import CustomIconButton from "@icarius-common/abmComponents/customIconButton";
import { getLocalizedString } from "@icarius-localization/strings";
import MyMapComponent from "./myMapComponent";

const AssistanceMap = (props) => {

    const {
        isLoading,
        data,
        handleClose,
    } = props;

    const goBackItem = () =>
        <CustomIconButton
            title={getLocalizedString("goBack")}
            onClick={handleClose}
            type={"goBack"}
        />

    const customHeader = () => (
        <Typography className="whiteText" style={{ fontSize: "16px", fontWeight: "500" }}>
            {getLocalizedString("onlyMarksWithGeopositionWillShow")}
        </Typography>
    );

    return (
        <CommonPage
            title={getLocalizedString("brandGeoposition")}
            isLoading={isLoading}
            menuItems={[goBackItem]}
            customHeader={customHeader}
            hideGrid
        >
            <MyMapComponent
                data={data}
                isMarkerShown
            />
        </CommonPage>
    );
}

export default AssistanceMap;